'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _TranslateComponent = require('./TranslateComponent');

var _TranslateComponent2 = _interopRequireDefault(_TranslateComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldLabel = function (_React$Component) {
    (0, _inherits3.default)(FieldLabel, _React$Component);

    function FieldLabel() {
        (0, _classCallCheck3.default)(this, FieldLabel);
        return (0, _possibleConstructorReturn3.default)(this, (FieldLabel.__proto__ || (0, _getPrototypeOf2.default)(FieldLabel)).apply(this, arguments));
    }

    (0, _createClass3.default)(FieldLabel, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                component = _props.component,
                other = (0, _objectWithoutProperties3.default)(_props, ['label', 'component']);


            var labelComponent = void 0;
            if (Array.isArray(label) || typeof label === 'string') {
                var labelProps = (0, _extends3.default)({
                    message: label,
                    component: component
                }, other);

                labelComponent = _react2.default.createElement(_TranslateComponent2.default, labelProps);
            } else {
                labelComponent = label;
            }

            return labelComponent;
        }
    }]);
    return FieldLabel;
}(_react2.default.Component); /**
                               * Label pro field, pokud se fieldy použijí s label=false, lze pro zobrazení jejich labelu použít tuto komponentu.
                               * Label se případně přeloží (pokud je pole (seznam stringů) nebo string).
                               * Použití:
                               * <FieldLabel label="aaaaaaa"/>
                               */


FieldLabel.propTypes = {
    component: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.array, _react2.default.PropTypes.func, _react2.default.PropTypes.bool]), // komponenta pro label, pokud je vstupem pole nebo string - převádí se přes TranslateComponent, standardně Label
    label: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.array])
};
FieldLabel.defaultProps = {
    component: _reactstrap.Label
};
exports.default = FieldLabel;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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